import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  SelectChangeEvent,
  Theme,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import DropdownInput from "common/components/DropdownInput";

const PREFIX = "NameAndGuidMultiSelectDropdown";

const classes = {
  formControl: `${PREFIX}-formControl`,
};

const StyledFormControl = styled(FormControl)(
  ({ theme }: { theme: Theme }) => ({
    [`&.${classes.formControl}`]: {
      maxWidth: 400,
      paddingBottom: theme.spacing(2),
    },
  })
);

interface NameAndGuidDropdownMenu {
  items: NameAndGuid[];
  disabled: boolean;
  onChange: (e: SelectChangeEvent<string[]>) => void;
  selectInputError: boolean;
  selectedItems: NameAndGuid[];
  label: string;
  name: string;
  required: boolean;
}

export class NameAndGuid {
  name?: string;
  guid?: string;
}

export {};

export default function NameAndGuidMultiSelectDropdown({
  disabled,
  onChange,
  items,
  selectInputError,
  selectedItems,
  label,
  name,
  required,
}: NameAndGuidDropdownMenu) {
  return (
    <StyledFormControl
      className={classes.formControl}
      disabled={disabled}
      error={selectInputError}
      fullWidth
    >
      <InputLabel
        id="nameAndGuid-select-label"
        variant="standard"
        shrink={true}
        error={selectInputError}
        required={required}
      >
        {label}
      </InputLabel>
      <Select
        labelId="nameAndGuid-select-label"
        id="nameAndGuid-select"
        value={selectedItems.map((item: NameAndGuid) => item.guid ?? "")}
        onChange={onChange}
        multiple={true}
        input={<DropdownInput />}
        error={selectInputError}
        renderValue={(selected) => {
          return selectedItems.map((item: NameAndGuid) => item.name).join(", ");
        }}
        name={name}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 500,
            },
          },
        }}
      >
        {items.map((nameAndGuid) => (
          <MenuItem value={nameAndGuid.guid} key={nameAndGuid.guid}>
            <Checkbox
              checked={
                selectedItems &&
                selectedItems.findIndex(
                  (selectedItem) => selectedItem.guid === nameAndGuid.guid
                ) > -1
              }
            />
            <ListItemText primary={nameAndGuid.name} />
          </MenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );
}
